/**
 * /frontend/src/features/analytics/components/offers/OfferFunnelChart.js
 */

import React from 'react';
import ChartContainer from '../shared/ChartContainer';
import FunnelChart from '../charts/FunnelChart';

/**
 * Offer funnel chart.
 * @param {{data:Array<{stage:string,count:number}>}} props
 * @returns {JSX.Element}
 */
const OfferFunnelChart = ({ data }) => (
  <ChartContainer title="Offer Funnel" subtitle="Viewed to claimed to redeemed">
    <FunnelChart data={data} />
  </ChartContainer>
);

export default OfferFunnelChart;

